import PropTypes from 'prop-types'
import React from 'react'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'

import { parseLocation, makeLink } from '../../../common/utils/urlHelper'
import DollarIcon from '../icons/dollar'
import SearchIcon from '../icons/search'
import RightOpenIcon from '../icons/rightOpen'

class FiltersPrice extends React.Component {
  static propTypes = {
    cost: PropTypes.object,
    location: PropTypes.object.isRequired
  }

  constructor(props) {
    super(props)
    const { location: { query } } = props

    this.state = {
      priceMin: query ? query.price_min : '',
      priceMax: query ? query.price_max : ''
    }
  }

  onPriceMinChange(event) {
    this.setState({ priceMin: event.target.value })
  }

  onPriceMaxChange(event) {
    this.setState({ priceMax: event.target.value })
  }

  onSubmit() {
    const parsedLocation = parseLocation(this.props.location)

    let nextQuery = Object.assign({}, parsedLocation, {
      price_min: this.state.priceMin,
      price_max: this.state.priceMax
    })
    delete nextQuery.page

    if (!this.state.priceMin) {
      delete nextQuery.price_min
    }

    if (!this.state.priceMax) {
      delete nextQuery.price_max
    }

    this.props.history.push(makeLink(nextQuery))
  }

  onEnter(event) {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.onSubmit()
    }
  }

  componentWillReceiveProps(nextProps) {
    const nextQuery = nextProps.location.query

    if (nextQuery.price_min !== this.state.priceMin) {
      this.setState({ priceMin: nextQuery.price_min || '' })
    }

    if (nextQuery.price_max !== this.state.priceMax) {
      this.setState({ priceMax: nextQuery.price_max || '' })
    }
  }

  render() {
    const { isAtTop } = this.props
    const panelHeaderClassNames = classNames({
      'search-facet-panel__header--start': isAtTop,
      'search-facet-box__inner': !isAtTop
    })
    const searchFacetBoxClassNames = classNames({
      'search-facet-box': !isAtTop
    })

    return (
      <div className="search-facet--no-margin" id="price-filter">
        <div className={searchFacetBoxClassNames}>
          <div className={panelHeaderClassNames}>
            <h2 className="search-facet-box__heading">
              <DollarIcon /> Price
              <span style={{ float: 'right' }}>
                <RightOpenIcon />
              </span>
            </h2>
            <div className="search-facet-range__inputs">
              <div className="search-facet-range__input--with-prefix">
                <label>From</label>
                <span>$</span>
                <input
                  type="number"
                  className="e-input"
                  placeholder={this.props.cost ? this.props.cost.min / 100 : ''}
                  value={this.state.priceMin}
                  onChange={this.onPriceMinChange.bind(this)}
                  onKeyPress={this.onEnter.bind(this)}
                />
              </div>
              <div className="search-facet-range__input--with-prefix">
                <label>To</label>
                <span>$</span>
                <input
                  type="number"
                  className="e-input"
                  placeholder={this.props.cost ? this.props.cost.max / 100 : ''}
                  value={this.state.priceMax}
                  onChange={this.onPriceMaxChange.bind(this)}
                  onKeyPress={this.onEnter.bind(this)}
                />
              </div>
              <div className="search-facet-range__input--submit">
                <button
                  type="button"
                  className="fds-c-button fds-u-p0 no-label"
                  onClick={this.onSubmit.bind(this)}
                >
                  <SearchIcon title="Apply" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export const FiltersPriceComponent = FiltersPrice
export default withRouter(FiltersPrice)



// WEBPACK FOOTER //
// ./client/components/filters/filtersPrice.js